<button class="btn primary save-btn full-width" (click)="save()" [disabled]="disabled"
    [ngClass]="disabled ? 'disabled' : ''" [matTooltip]="tooltip">{{buttonText}}
    <span class="spinner-wrapper" *ngIf="loading">
        <mat-spinner [diameter]="18"></mat-spinner>
    </span>
</button>